import api from "./Api";

class FornecedorService {
  GetFornecedor(payload) {
    return api.get("/v1/fornecedor/" + payload).then((response) => {
      return response.data;
    });
  }

  PostFornecedor(payload) {
    return api.post("/v1/fornecedor/", payload).then((response) => {
      return response.data;
    });
  }

  PutFornecedor(payload) {
    return api.put("/v1/fornecedor/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteFornecedor(payload) {
    return api.delete("/v1/fornecedor/" + payload).then((response) => {
      return response.data;
    });
  }

  GetFornecedorOData(payload) {
    return api.get("/OData/Fornecedor" + payload).then((response) => {
      return response.data;
    });
  }

  Validate(payload) {
    return api.post("/v1/fornecedor/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/fornecedor/Converter/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new FornecedorService();
